export default "__VITE_ASSET__DKuaUpLj__"